import { useContext } from "react";
import { Link, useLocation } from 'react-router-dom';

import { DataContext } from "providers/DataProvider";
import PWAInstallPrompt from "components/PWAInstallPrompt";
import { useTheme } from "providers/ThemeProvider";

import 'styles/Navbar.css';
import { BugIcon } from "components/Icons";

export default function MobileNavBar() {

  const { me, isInStandaloneMode } = useContext(DataContext);
  const { theme, setTheme } = useTheme();
  const location = useLocation();

  return (
    <nav className="mobile-navbar">
      <div className="navbar-left">
        { location.pathname === '/'                 && "Home"}
        { location.pathname === '/create-activity'  && "Create activity"}
        { location.pathname === '/create-group'     && "Create group"}
        { location.pathname === '/profile'          && "Profile"}
        { location.pathname === '/login'            && "Log in"}
        { location.pathname === '/signup'           && "Sign up"}
        { location.pathname === '/team'             && "Team"}
        { location.pathname === '/notifications'    && "Notifications"}
        { location.pathname === '/forgot-password'  && "Forgot password"}
        { location.pathname === '/logout'           && "Log out"}
        { location.pathname === '/reset-password'   && "Reset password"}
        { location.pathname.startsWith('/g/')       && "Group"}
        { location.pathname.startsWith('/t/')       && "Tag"}
        { location.pathname === '/bug'              && "Report a bug"}
      </div>
      <div className="navbar-right">
        {
          me?.email
            ? (location.pathname === '/profile')
              ? <Link className="nav-link" to="/logout">Log out</Link>
              : null
            : null
        }
        {
          isInStandaloneMode ||
          <div className="nav-link">
            <PWAInstallPrompt/>
          </div>
        }
        <Link className="nav-link" to="/bug" style={{padding: '5px'}}>
          <BugIcon/>
        </Link>
        <button onClick={()=>setTheme(theme === 'bluish' ? 'cloud' : 'bluish')} style={{opacity: 0, height: '100%'}}>
          {theme === 'bluish' ? 'Cloud' : 'Bluish'}
        </button>
      </div>
    </nav>
  );
}